<template>
  <v-container fluid>
    <PageHeading
      :text="'Гиды'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-guide-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Добавить гида
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridGuides ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridGuides from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageGuides',
  components: {
    PageHeading,
    GridGuides
  },
  metaInfo () {
    return {
      title: 'Гиды'
    }
  },
  mixins: [gridPageInterface]
}
</script>
